import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';


const DeviceContractTable = ({
  deviceContractsList,
  availableDevices,
  addDeviceToContract,
  removeDeviceFromContract,
  isEditMode,

  coverageOptions,
  coverageTypeOptions,
  setDeviceContractsList

}) => {

  const [newDeviceId, setNewDeviceId] = useState('');





  const getDeviceLabel = (deviceId, availableDevices) => {
    const device = availableDevices?.find((device) => device.deviceId === deviceId);
    return device ? device.deviceId + ' - ' + (device.deviceName || 'N/A') + ' - ' + (device.address || 'N/A') : 'N/A';
  }


  const updateDeviceField = (index, field, value) => {
    const updatedDevices = [...deviceContractsList];
    updatedDevices[index][field] = value;
    setDeviceContractsList(updatedDevices);
  }


  console.log(coverageOptions, coverageTypeOptions);

  return (
    <div className="mb-4">
      {/* Add Device Section */}
      {isEditMode && (
        <div className="m-4">
          <div className="flex flex-row justify-start items-center">
            <div className="flex-grow">

              <select


                id="device-select"
                className="border p-2 rounded-md w-full h-10"
                value={newDeviceId}
                onChange={(e) => setNewDeviceId(Number(e.target.value))}
                disabled={availableDevices.length === 0}
              >
                <option value="" disabled>
                  {getDeviceLabel(newDeviceId) || 'Select Device'}
                </option>
                {availableDevices.map((device) => (
                  <option key={device.deviceId} value={device.deviceId}>
                    {getDeviceLabel(device.deviceId, availableDevices)}
                  </option>
                ))}
              </select>


            </div>
            <div className="flex-grow">
              <button
                className="mx-2 px-4 py-2 border rounded-md bg-sss-blue text-white font-semibold hover:border-sss-accent-yel"
                onClick={() => addDeviceToContract(newDeviceId)}
              >
                Add Device
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Devices Table */}
      <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
        <thead className="bg-gray-200">
          <tr>

            <th className="px-4 py-2 text-left font-bold text-sss-blue-sel border bg-gray-200">Contract ID</th>
            <th className="px-4 py-2 text-left font-bold text-sss-blue-sel border bg-gray-200">Device ID</th>
            <th className="px-4 py-2 text-left font-bold text-sss-blue-sel border bg-gray-200">Coverage Type</th>
            <th className="px-4 py-2 text-left font-bold text-sss-blue-sel border bg-gray-200">Coverage</th>
            {isEditMode && <th className="px-4 py-2 text-left font-bold text-sss-blue-sel border bg-gray-200"></th>}

          </tr>
        </thead>
        <tbody>
          {deviceContractsList && deviceContractsList.map((device, index) => (
            <tr key={device.deviceId}>

              <td className="px-2 py-2 border">{device.contractId}</td>
              <td className="px-2 py-2 border">{getDeviceLabel(device.deviceId, availableDevices)}</td>
              <td className="px-2 py-2 border">
                {
                  isEditMode ? (

                    <select name="coverageType" id="coverageType" className="border p-2 rounded-md w-full h-10" value={device.coverageType} onChange={(e) => updateDeviceField(index, 'coverageType', e.target.value)}>
                      {coverageTypeOptions.map((option) => (
                        <option key={option.coverageTypeName} value={option.coverageTypeName}>
                          {option.coverageTypeName}
                        </option>
                      ))}
                    </select>

                  ) : (

                    <>{device.coverageType}</>

                  )
                }</td>
                <td className="px-2 py-2 border">
              {
                isEditMode ? (


                  <select name="coverage" id="coverage" className="border p-2 rounded-md w-full h-10" value={device.coverage} onChange={(e) => updateDeviceField(index, 'coverage', e.target.value)}>
                    {coverageOptions.map((option) => (
                      <option key={option.coverageName} value={option.coverageName}>
                        {option.coverageName}
                      </option>
                    ))}
                  </select>


                ) : (
                  <>{device.coverage}</>

                )
              }
              </td>
              {isEditMode && (
                <td className="p-2 border text-center">
                  <button
                    onClick={() => removeDeviceFromContract(device.deviceId)}
                    className="hover:bg-red-500 rounded-xl transition ease-in-out border-2 p-2 border-gray-300"
                  >
                    <DeleteIcon />
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DeviceContractTable;
